import '../services.css';

const GraphicDesigning = () => {
    return (
        <div className="cover w-100">
            {/* Hero Section */}
            <div className="service-hero-section text-white py-5 text-center bg-primary">
                <h1 className="display-4 fw-bold mb-3">Graphic Designing</h1>

            </div>

            {/* Web Development Section */}
            <div className="container py-5">
                <div className="row align-items-center">
                    {/* Left - Text */}
                    <div className="col-md-8 mb-4 mb-md-0">
                        <p className="text-justify">
                            Here at Panorama we add value to everything we do, from visuals, web strategy, user experience, to development and marketing. We create work that is inspired, effective, and intelligent for your brand. We are well-known for our exquisite designs and web-related Services.
                        </p>
                        <p className="text-justify">
                            Logo Design, Packaging Design, Brochure & Catalogue Design, and Print Advertisements are all part of our Graphic Designing service. Graphic design is the visual representation of an idea, message, or imagination. Logos, brochures, catalogues, and print advertisements, is what truly represents a company.
                        </p>
                        <p className="text-justify">
                            Graphic design is essential for product branding, from designing the company or organization’s emblem, which gives it a distinct character, to preparing promotional material for the advertising of its products and services.
                        </p>
                    </div>

                    {/* Right - Image */}
                    <div className="image-area col-md-4 text-center text-md-end h-100">
                        <img
                            src="assets\images\service\graphic.png"
                            alt="Graphic Desiging"
                           style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </div>
                </div>
            </div>

            {/* WEB DEVELOPMENT */}
            <div className="container py-2  ">
                {/* Unique Web Design */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">WEB DEVELOPMENT</h3>
                    <p className="text-justify">
                        The web is a global marketplace that has become more competitive for attention of potential clients. As a result, having a professionally built and visually appealing website is more crucial than ever.
                    </p>
                </div>

                {/* PRINT DESIGNS */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">PRINT DESIGNS</h3>
                    <p className="text-justify">
                        What are the primary design services offered by a Graphic Design Agency? Flyer and Leaflet.Designing, Poster Designing, Dangler Designing, Advertisement Designing, Exhibition Stall.Designing, Creative Designs for Facebook Marketing, and Magazine Advertisement.Designing are some of the services offered. At Panorama you’ll get the best service at minimum price!
                    </p>
                </div>

                {/* LOGO DESIGNS */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">LOGO DESIGNS</h3>
                    <p className="text-justify">
                        We consider a logo to be the face of your organization. It is the first thing that a potential customer will notice about your business; therefore, when designing a logo, we keep in mind that a logo should be designed in such a way that it can convey to potential customers that your business is professional, trustworthy, and provides quality goods or services.  
                    </p>
                </div>

            </div>
        </div>
    );
};

export default GraphicDesigning;
